var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import PersistentCollection from '../PersistentCollection';
import FilterRuleContainsString from '../filters/FilterRuleContainsString';
import ServiceAssetSchemaModel from '../../models/ServiceAssetSchemaModel';
/**
 *
 */
var ServiceAssetSchemaCollection = /** @class */ (function (_super) {
    __extends(ServiceAssetSchemaCollection, _super);
    /**
     * isPersistent
     */
    function ServiceAssetSchemaCollection(isPersistent) {
        if (isPersistent === void 0) { isPersistent = false; }
        var _this = _super.call(this, ServiceAssetSchemaModel, isPersistent, 'ServiceAssetSchemaCollection') || this;
        _this.searchStringFilter = new FilterRuleContainsString('filterString');
        _this.filter.addRule(_this.searchStringFilter);
        return _this;
    }
    return ServiceAssetSchemaCollection;
}(PersistentCollection));
export default ServiceAssetSchemaCollection;
